module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "lee-header justify-between"
  }, [_c('div', {
    staticClass: "left justify-box"
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "width": "50",
      "height": "50"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "success-text"
  }, [_vm._v("VUE")]), _c('span', [_vm._v("HOMEPAGE")])]), _vm._v(" "), _c('div', {
    staticClass: "command-bar justify-box"
  }, [_c('div', {
    staticClass: "notification-info"
  }, [_c('el-dropdown', [_c('span', {
    staticClass: "el-dropdown-link"
  }, [_c('el-badge', {
    staticClass: "item primary-text",
    attrs: {
      "is-dot": ""
    }
  }, [_c('i', {
    staticClass: "fa fa-bell"
  })])], 1), _vm._v(" "), _c('el-dropdown-menu', {
    slot: "dropdown"
  }, [_c('el-dropdown-item', {
    staticClass: "title",
    attrs: {
      "disabled": ""
    }
  }, [_vm._v("notification")]), _vm._v(" "), _vm._l((4), function(message) {
    return _c('el-dropdown-item', {
      key: message,
      attrs: {
        "divided": ""
      }
    }, [_c('div', {
      staticClass: "message justify-between"
    }, [_c('div', {
      staticClass: "text primary-text"
    }, [_vm._v("You received a friend request")]), _vm._v(" "), _c('div', {
      staticClass: "date"
    }, [_vm._v("2 hours ago")])])])
  }), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    }
  }, [_vm._v("view more messages")])], 2)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "account-info"
  }, [_c('el-popover', {
    ref: "popover",
    attrs: {
      "placement": "bottom",
      "width": "100",
      "trigger": "hover"
    }
  }, [_c('div', {
    staticClass: "list"
  }, [_c('div', {
    staticClass: "list-item"
  }, [_vm._v("Your profile")]), _vm._v(" "), _c('div', {
    staticClass: "list-item"
  }, [_vm._v("Friends list")]), _vm._v(" "), _c('div', {
    staticClass: "popover-divider"
  }), _vm._v(" "), _c('div', {
    staticClass: "list-item"
  }, [_vm._v("Settings")]), _vm._v(" "), _c('div', {
    staticClass: "list-item",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("Log out")])])]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "popover",
      rawName: "v-popover:popover",
      arg: "popover"
    }],
    staticClass: "account-info-btn"
  }, [_c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.photo
    }
  }), _vm._v(" "), _c('i', {
    staticClass: "fa fa-caret-down"
  })])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4ac17f8f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 600
// module chunks = 1